import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { Fade } from '@chakra-ui/react';
import './GuiaDeAjuda.scss';
import fotoPaginaDevelopers from '../../assets/photo/paginaDevelopers.png';
import telaApp from '../../assets/photo/telaapp.png';
import telaProduto1 from '../../assets/photo/telaprodutos1.png';
import telaProduto2 from '../../assets/photo/telaprodutos2.png';
import telaAuth1 from '../../assets/photo/telaauth.png'
import telaAuth2 from '../../assets/photo/telaauth2.png'
import telaAuth3 from '../../assets/photo/telaauth3.png'
import telaAuth4 from '../../assets/photo/telaauth4.png'
import telaauthconfig from '../../assets/photo/telaauthconfig.png'
import telaauthconfig2 from '../../assets/photo/telaauthconfig2.png'
import telaauthconfig3 from '../../assets/photo/telaauthconfig3.png'
import telaverify from '../../assets/photo/telaverify.png'
import telaverify2 from '../../assets/photo/telaverify2.png'
import telaverify3 from '../../assets/photo/telaverify3.png'
import telaverify4 from '../../assets/photo/telaverify4.png'
import telaverify5 from '../../assets/photo/telaverify5.png'
import telaconfigcms from '../../assets/photo/telaconfigcms.png'
import telaappinicio from '../../assets/photo/telaappinicio.png'
import telatoken1 from '../../assets/photo/telatoken1.png'
import telatoken2 from '../../assets/photo/telatoken2.png'
import telatokencms from '../../assets/photo/telatokencms.png'
import telaAposToken from '../../assets/photo/telaapostoken.png'
import linkedindBanner from '../../assets/photo/linkedin-banner.webp'

import telaInstagramFace1 from '../../assets/photo/telaInstagramFace1.png'
import telaInstagramFace2 from '../../assets/photo/telaInstagramFace2.png'
import telaInstagramFace3 from '../../assets/photo/telaInstagramFace3.png'
import telaInstagramFace4 from '../../assets/photo/telaInstagramFace4.png'
import telaInstagramFace5 from '../../assets/photo/telaInstagramFace5.png'
import telaInstagramFace6 from '../../assets/photo/telaInstagramFace6.png'
import telaInstagramFace7 from '../../assets/photo/telaInstagramFace7.png'
import telaInstagramFace8 from '../../assets/photo/telaInstagramFace8.png'
import telaInstagramFace9 from '../../assets/photo/telaInstagramFace9.png'
import telaInstagramFace10 from '../../assets/photo/telaInstagramFace10.png'
import telaInstagramFace11 from '../../assets/photo/telaInstagramFace11.png'
import telaInstagramFace12 from '../../assets/photo/telaInstagramFace12.png'
import telaInstagramFace13 from '../../assets/photo/telaInstagramFace13.png'
import telaInstagramFace14 from '../../assets/photo/telaInstagramFace14.png'
import telaInstagramFace15 from '../../assets/photo/telaInstagramFace15.png'
import telaInstagramFace16 from '../../assets/photo/telaInstagramFace16.png'
import telaInstagramFace17 from '../../assets/photo/telaInstagramFace17.png'
import telaInstagramFace18 from '../../assets/photo/telaInstagramFace18.png'
import telaInstagramFace19 from '../../assets/photo/telaInstagramFace19.png'
import telaInstagramFace20 from '../../assets/photo/telaInstagramFace20.png'
import telaInstagramFace21 from '../../assets/photo/telaInstagramFace21.png'
import telaInstagramFace22 from '../../assets/photo/telaInstagramFace22.png'
import telaInstagramFace23 from '../../assets/photo/telaInstagramFace23.png'
import telaInstagramFace24 from '../../assets/photo/telaInstagramFace24.png'
import telaInstagramFace24Grifada from '../../assets/photo/telaInstagramFace24Grifada.png'
import telaInstagramFace25 from '../../assets/photo/telaInstagramFace25.png'
import telaInstagramFace26 from '../../assets/photo/telaInstagramFace26.png'
import telaInstagramFace27 from '../../assets/photo/telaInstagramFace27.png'
import telaInstagramFace28 from '../../assets/photo/telaInstagramFace28.png'
import telaInstagramFace29 from '../../assets/photo/telaInstagramFace29.png'
import telaInstagramFace30 from '../../assets/photo/telaInstagramFace30.png'
import telaInstagramFace31 from '../../assets/photo/telaInstagramFace31.png'
import telaInstagramFace32 from '../../assets/photo/telaInstagramFace32.png'
import instagramBanner from '../../assets/photo/banner-instagram.png'
import facebookBanner from '../../assets/photo/banner-facebook.jpg'

interface HelpGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
  socialMedia: string;
}

interface GuideStep {
  titulo: string;
  descricao: string;
  imagemUrl: string;
  fieldHighlight?: string;
}

const HelpGuideModal: React.FC<HelpGuideModalProps> = ({ isOpen, onClose, socialMedia }) => {
  const [passoAtual, setPassoAtual] = useState<number>(0);

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
  };

  const getPassosDaGuia = (): GuideStep[] => {
    const passosComuns: GuideStep[] = [
    ];

    if (socialMedia === 'Linkedin') {
      return [
        ...passosComuns.slice(0, 1),
        {
          titulo: "Criar aplicativo no LinkedIn",
          descricao:
            `Para configurar o LinkedIn no CMS, crie uma aplicação em <a href="https://developer.linkedin.com/" target="_blank" rel="noopener noreferrer" style="color: #2563eb;">https://developer.linkedin.com/</a> clicando em "Create app". Faça login, se necessário.`,
          imagemUrl: fotoPaginaDevelopers,
        },
        {
          titulo: "Revisar configurações iniciais",
          descricao:
            `Em seguida, você será redirecionado para a tela "Create an app", em que as configurações iniciais serão apresentadas para facilitar o processo.`,
          imagemUrl: telaApp,
        },
        {
          titulo: "Selecionar página do LinkedIn",
          descricao:
            `Se você já possuir uma página, insira sua URL em "LinkedIn Page". Caso contrário, clique em "Create a new LinkedIn Page", siga os passos e retorne à tela "Create an app".`,
          imagemUrl: telaappinicio,
        },
        {
          titulo: "Inserir URL da página no CMS",
          descricao:
            `Na plataforma CMS, adicione a URL da página do LinkedIn que foi criada em "Página do Linkedin para publicação". Certifique-se de que o endereço está correto para concluir a configuração com sucesso.`,
          imagemUrl: telaconfigcms,
        },
        {
          titulo: "Aceitar termos",
          descricao:
            `Após a configuração, acesse "Products" e clique em "Request Access" (primeiro item da lista). Ele abrirá um modal. Em seguida, aceite os termos.`,
          imagemUrl: telaProduto1,
        },
        {
          titulo: "Aceitar termos",
          descricao:
            `Na mesma lista, clique em “Sign In with LinkedIn using OpenID Connect”. Essa ação também abrirá um modal. Em seguida, aceite os termos.`,
          imagemUrl: telaProduto2,
        },
        {
          titulo: "Acessar OAuth 2.0 tools",
          descricao:
            `Agora, clique em "Auth". Nesta página, do lado direito, haverá um texto e nele um link em azul chamado "OAuth 2.0 tools". Clique no link.`,
          imagemUrl: telaAuth1,
        },
        {
          titulo: "Gerar token",
          descricao:
            `Você será direcionado à página de configuração do token. Clique no botão azul "Create token" para ir à tela "Create OAuth 2.0 access token".`,
          imagemUrl: telaAuth2,
        },
        {
          titulo: "Selecionar opções do token",
          descricao:
            `Na tela "Create OAuth 2.0 access token", marque as opções indicadas na imagem e as que serão informadas na etapa seguinte.`,
          imagemUrl: telaAuth3,
        },
        {
          titulo: "Obter token de acesso",
          descricao:
            `Após selecionar todos os campos, verifique cuidadosamente se cada campo foi marcado corretamente. Depois de validar, clique em "Request access token".`,
          imagemUrl: telaAuth4,
        },
        {
          titulo: "Realizar login para o token",
          descricao:
            `Após clicar em "Request access token", será solicitado que você realize o seu login em sua conta no LinkedIn. Efetue o login para prosseguir.`,
          imagemUrl: telatoken1,
        },
        {
          titulo: "Copiar token de acesso",
          descricao:
            `Ao efetuar o login, você será redirecionado para a página "Create OAuth 2.0 access token", que exibirá o campo "access token". Copie-o em "Copy access token".`,
          imagemUrl: telatoken2,
        },
        {
          titulo: "Inserir token no CMS",
          descricao:
            `Após ter copiado o token de acesso em "Copy access token", cole-o no campo "Token de acesso" na plataforma CMS, conforme mostrado na imagem.`,
          imagemUrl: telatokencms,
        },
        {
          titulo: "Voltar para tela de configuração",
          descricao:
            `Após ter copiado o token de acesso, volte para a página de configuração do LinkedIn, clicando em "My apps" e selecionando o seu app utilizado na configuração`,
          imagemUrl: telaAposToken,
        },
        {
          titulo: "Copiar Client ID",
          descricao:
            `Após ter voltado para a página de configuração do LinkedIn, acesse a aba "Auth" e copie o "Client ID" exibido em "Application credentials".`,
          imagemUrl: telaauthconfig,
        },
        {
          titulo: "Copiar URL de redirecionamento",
          descricao:
            `Ainda em "Auth", copie também a URL de redirecionamento autorizada (Authorized redirect URLs for your app), conforme indicado.`,
          imagemUrl: telaauthconfig2,
        },
        {
          titulo: "Inserir credenciais no CMS",
          descricao:
            `Depois de copiar os dois itens, cole-os nos campos "Chave de API" e "Url de redirecionamento autorizada" na plataforma CMS, conforme mostrado.`,
          imagemUrl: telaauthconfig3,
        },
        {
          titulo: "Verificar configuração",
          descricao:
            `Com os campos do CMS preenchidos corretamente, conforme o passo a passo fornecido, retorne à configuração do LinkedIn, acesse a aba "Settings" e clique em "Verify".`,
          imagemUrl: telaverify,
        },
        {
          titulo: "Gerar URL de verificação",
          descricao:
            `Após clicar em "Verify", abrirá um modal que mostrará as informações de verificação. Clique em "Generate URL" para criar sua URL.`,
          imagemUrl: telaverify2,
        },
        {
          titulo: "Copiar URL de verificação",
          descricao:
            `Depois de gerar a URL, copie-a, mas mantenha o modal aberto. Essa URL é essencial para prosseguir com a verificação, portanto, certifique-se de que ela foi copiada corretamente.`,
          imagemUrl: telaverify3,
        },
        {
          titulo: "Verificar URL no navegador",
          descricao:
            `Após a cópia da URL da etapa anterior, abra uma nova aba no navegador e cole a URL na barra de pesquisa, assim, abrirá uma tela de verificação e, em seguida, clique em "Verify".`,
          imagemUrl: telaverify4,
        },
        {
          titulo: "Finalizar verificação",
          descricao:
            `Após a verificação, retorne à aba com o modal exibindo a URL copiada. Clique no botão "I'm done" da etapa 18 e recarregue a página. Se tudo ocorrer conforme esperado, o status verificado aparecerá na página da empresa.`,
          imagemUrl: telaverify5,
        },
        {
          titulo: "Configuração concluída",
          descricao:
            `Parabéns! A configuração foi concluída com sucesso e você já pode publicar no LinkedIn.`,
          imagemUrl: linkedindBanner,
        },
        ...passosComuns.slice(2),
      ];
    } else if (socialMedia === 'Instagram') {
      return [
        ...passosComuns.slice(0, 1),
        {
          titulo: "Configuração inicial para o Instagram",
          descricao:
            `Para configurar o Instagram no CMS, acesse <a href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer" style="color: #2563eb;">https://developers.facebook.com/apps/</a>, faça o login em sua conta, clique em "Começar" e siga os passos pedidos.`,
          imagemUrl: telaInstagramFace32,
        },
        {
          titulo: "Criar aplicativo no Instagram",
          descricao:
            `Ao completar os passos, você será redirecionado para a página demonstrada na imagem. Caso não seja redirecionado, acesse a URL anterior novamente. Em seguida, clique em "Criar Aplicativo".`,
          imagemUrl: telaInstagramFace1,
        },
        {
          titulo: "Revisar configurações iniciais",
          descricao:
            `Nomeie o app e prossiga com a criação.`,
          imagemUrl: telaInstagramFace2,
        },
        {
          titulo: "Marcar campos obrigatórios",
          descricao:
            `Ao avançar, aparecerá uma lista, desça para o final da página em "Procurando outra coisa?" e marque o campo "Outro". Em seguida, avance.`,
          imagemUrl: telaInstagramFace3,
        },
        {
          titulo: "Selecionar tipo de aplicativo",
          descricao:
            `Após avançar, você será redirecionado para "Criar um app". Selecione o tipo de aplicativo como "Empresa" e avance.`,
          imagemUrl: telaInstagramFace4,
        },
        {
          titulo: "Criar aplicativo",
          descricao:
            `Assim, você será redirecionado para uma página onde contém as informações do seu aplicativo. Clique em "Criar aplicativo".`,
          imagemUrl: telaInstagramFace5,
        },
        {
          titulo: "Configurar Instagram",
          descricao:
            `Ao ser redirecionado para a página "Adicionar produtos ao seu aplicativo", clique em "Configurar" no ícone da mídia social Instagram.`,
          imagemUrl: telaInstagramFace6,
        },
        {
          titulo: "Ir em funções do app",
          descricao:
            `Em seguida, clique em "Funções do app", no menu do lado esquerdo.`,
          imagemUrl: telaInstagramFace7,
        },
        {
          titulo: "Ir em funções",
          descricao:
            `Em "Funções do app", clique em "Funções".`,
          imagemUrl: telaInstagramFace8,
        },
        {
          titulo: "Adicionar pessoas ao seu aplicativo",
          descricao:
            `Agora, clique no botão azul "Adicionar pessoas ao seu aplicativo".`,
          imagemUrl: telaInstagramFace9,
        },
        {
          titulo: "Marcar e adicionar campos obrigatórios",
          descricao:
            `Ao clicar no botão, abrirá o modal e será necessário marcar o campo "Funções adicionais para este app". Em seguida, no campo abaixo, insira o nome do usuário da conta do Instagram que deseja adicionar e clique no botão azul "Adicionar".`,
          imagemUrl: telaInstagramFace10,
        },
        {
          titulo: "Ir para Apps e sites",
          descricao:
            `Ao realizar a etapa anterior, ainda em "Funções de aplicativo", dentro da tabela no campo "Função" aparecerá o perfil adicionado como "Testador do Instagram". Em seguida, clique em "Apps e sites".`,
          imagemUrl: telaInstagramFace11,
        },
        {
          titulo: "Aceitar termos no aplicativo Instagram",
          descricao:
            `Ao clicar em "Apps e sites", você será redirecionado ao Instagram. Caso não esteja logado, será necessário fazer o login. Em seguida, clique na aba "Convites Do Testador" e aceite o convite clicando no botão azul "Aceitar".`,
          imagemUrl: telaInstagramFace12,
        },
        {
          titulo: "Voltar para o Meta",
          descricao:
            `Após aceitar, volte para o aplicativo Meta e, no cabeçalho da página, clique em "Ferramentas" e, em seguida, em "Explorador da Graph API".`,
          imagemUrl: telaInstagramFace13,
        },
        {
          titulo: "Adicionar permissões",
          descricao:
            `Em seguida, no campo "Permissões" é necessário adicionar os itens "instagram_basic", "pages_show_list", "instagram_content_publish", "pages_read_engagement" e "business_management". Depois, clique em "Generate Acess Token".`,
          imagemUrl: telaInstagramFace14,
        },
        {
          titulo: "Gerar token de acesso",
          descricao:
            `Ao clicar em "Generate Access Token", você precisará autenticar com o Facebook. Clique no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace15,
        },
        {
          titulo: "Aceitar páginas atuais e no futuro",
          descricao:
            `Em seguida, no modal, selecione a opção "Aceitar todos(as) Páginas atuais e no futuro". E em seguida, clique no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace16,
        },
        {
          titulo: "Aceitar empresas atuais e no futuro",
          descricao:
            `Depois, selecione a opção "Aceitar todos(as) Empresas atuais e no futuro". Clique novamente no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace17,
        },
        {
          titulo: "Aceitar contas atuais e no futuro",
          descricao:
            `Ao aceitar, selecione a opção "Aceitar todos(as) Contas do Instagram atuais e no futuro". E, em seguida, clique no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace18,
        },
        {
          titulo: "Salvar alterações",
          descricao:
            `Ao aceitar todos os termos anteriormente, clique no botão azul "Salvar".`,
          imagemUrl: telaInstagramFace19,
        },
        {
          titulo: "Finalizar autenticação",
          descricao:
            `Ao salvar, aparecerá uma mensagem de sucesso. Em seguida, clique em "Entendi".`,
          imagemUrl: telaInstagramFace20,
        },
        {
          titulo: "Copiar token de acesso",
          descricao:
            `Ao fechar o modal de autenticação, o seu token será gerado. Clique no ícone mostrado na imagem e copie o token de acesso.`,
          imagemUrl: telaInstagramFace21,
        },
        {
          titulo: "Ir para configurações do app",
          descricao:
            `Em seguida, volte para a página do Meta e clique na barra lateral em "Configurações do app" e "Básico".`,
          imagemUrl: telaInstagramFace22,
        },
        {
          titulo: "Copiar campos",
          descricao:
            `Você será direcionado para as páginas com os campos "ID de Aplicativo" e "Chave Secreta do Aplicativo". Copie esses dois campos.`,
          imagemUrl: telaInstagramFace23,
        },
        {
          titulo: "Ajustar url e copiar seu retorno gerado",
          descricao:
            `Ao copiar os campos, cole-os nas partes entre chaves da url destacada abaixo, juntamente com o token de acesso. Após a url ajustada, cole-a na barra de pesquisa e copie o token que será gerado na tela (necessário remover as chaves "{ }" antes do envio, e verificar se não há nenhum espaço em branco).`,
          imagemUrl: telaInstagramFace24Grifada,
          fieldHighlight: `https://graph.facebook.com/v19.0/oauth/access_token?grant_type=fb_exchange_token&client_id={ID de aplicativo}&client_secret={Chave Secreta do Aplicativo}&fb_exchange_token={Token de acesso}`
        },
        {
          titulo: "Colar token de acesso no CMS",
          descricao:
            `Após a cópia do token, acesse a plataforma CMS e cole-o no campo "Token de acesso".`,
          imagemUrl: telaInstagramFace27,
        },
        {
          titulo: "Colar retorno de token e copiar campos",
          descricao:
            `Com o mesmo token copiado, coloque-o no campo "Token de acesso" da url destacada abaixo e cole essa url na barra de pesquisa do navegador (necessário remover as chaves "{ }" antes do envio, e verificar se não há nenhum espaço em branco). Em seguida, aparecerá os campos descritos na imagem, então, copie o campo "id".`,
          imagemUrl: telaInstagramFace25,
          fieldHighlight: "https://graph.facebook.com/v19.0/me/accounts?access_token={Token de acesso}"
        },
        {
          titulo: "Colar retorno de token e copiar campos",
          descricao:
            `Com o id e token copiado, coloque-os no campo "Token de acesso" e "Page ID" da url destacada abaixo e cole essa url na barra de pesquisa do navegador (necessário remover as chaves "{ }" antes do envio, e verificar se não há nenhum espaço em branco). Em seguida, aparecerá os campos descritos na imagem, dentro de "instagram_business_account", copie o campo "id".`,
          imagemUrl: telaInstagramFace26,
          fieldHighlight: "https://graph.facebook.com/v19.0/{Page ID}?fields=instagram_business_account&access_token={Token de acesso}"
        },
        {
          titulo: "Colar campos",
          descricao:
            `Ao copiar o id, volte para a plataforma CMS, e coloque-o no campo "User ID". E o campo "Nome do usuário" é o nome de sua preferência.`,
          imagemUrl: telaInstagramFace29,
        },
        {
          titulo: "Configuração concluída",
          descricao:
            `Parabéns! A configuração foi concluída com sucesso e você já pode publicar no Instagram.`,
          imagemUrl: instagramBanner,
        },
      ]
    } else if (socialMedia === 'Facebook') {
      return [
        ...passosComuns.slice(0, 1),
        {
          titulo: "Configuração inicial para o Facebook",
          descricao:
            `Para configurar o Facebook no CMS, acesse <a href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer" style="color: #2563eb;">https://developers.facebook.com/apps/</a>, faça o login em sua conta, clique em "Começar" e siga os passos pedidos.`,
          imagemUrl: telaInstagramFace32,
        },
        {
          titulo: "Criar aplicativo no Facebook",
          descricao:
            `Ao completar os passos, você será redirecionado para a página demonstrada na imagem. Caso não seja redirecionado, acesse a URL anterior novamente. Em seguida, clique em "Criar Aplicativo".`,
          imagemUrl: telaInstagramFace1,
        },
        {
          titulo: "Revisar configurações iniciais",
          descricao:
            `Nomeie o app e prossiga com a criação.`,
          imagemUrl: telaInstagramFace2,
        },
        {
          titulo: "Marcar campos obrigatórios",
          descricao:
            `Ao avançar, aparecerá uma lista, desça para o final da página em "Procurando outra coisa?" e marque o campo "Outro". Depois, siga para a outra página.`,
          imagemUrl: telaInstagramFace3,
        },
        {
          titulo: "Selecionar tipo de aplicativo",
          descricao:
            `Após avançar, você será redirecionado para "Criar um app". Selecione o tipo de aplicativo como "Empresa" e avance.`,
          imagemUrl: telaInstagramFace4,
        },
        {
          titulo: "Criar aplicativo",
          descricao:
            `Assim, você será redirecionado para uma página onde contém as informações do seu aplicativo. Clique em "Criar aplicativo".`,
          imagemUrl: telaInstagramFace5,
        },
        {
          titulo: "Ir em Explorador da Graph API",
          descricao:
            `Em seguida, no cabeçalho da página, clique em "Ferramentas" e, em seguida, "Explorador da Graph API".`,
          imagemUrl: telaInstagramFace13,
        },
        {
          titulo: "Adicionar permissões",
          descricao:
            `Nesta página, no campo "Usuário ou página", selecione a opção "Obter token de acesso da página".`,
          imagemUrl: telaInstagramFace31,
        },
        {
          titulo: "Adicionar permissões",
          descricao:
            `Em seguida, no campo "Permissões" é necessário adicionar os items "instagram_basic", "pages_show_list", "instagram_content_publish", "pages_read_engagement" e "business_management". Depois, clique em "Generate Acess Token".`,
          imagemUrl: telaInstagramFace14,
        },
        {
          titulo: "Gerar token de acesso",
          descricao:
            `Ao clicar em "Generate Acess Token", você precisará autenticar com o Facebook. Clique no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace15,
        },
        {
          titulo: "Aceitar páginas atuais e no futuro",
          descricao:
            `Em seguida, no modal, selecione a opção "Aceitar todos(as) Páginas atuais e no futuro". Agora, clique no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace16,
        },
        {
          titulo: "Aceitar empresas atuais e no futuro",
          descricao:
            `Em seguida, selecione a opção "Aceitar todos(as) Empresas atuais e no futuro". Clique novamente no botão azul "Continuar".`,
          imagemUrl: telaInstagramFace17,
        },
        {
          titulo: "Salvar alterações",
          descricao:
            `Ao aceitar todos os termos anteriormente, clique no botão azul "Salvar".`,
          imagemUrl: telaInstagramFace19,
        },
        {
          titulo: "Finalizar autenticação",
          descricao:
            `Ao salvar, aparecerá uma mensagem de sucesso. Em seguida, clique em "Entendi".`,
          imagemUrl: telaInstagramFace20,
        },
        {
          titulo: "Copiar token de acesso",
          descricao:
            `Ao fechar o modal de autenticação, o seu token será gerado. Clique no ícone mostrado na imagem e copie o token de acesso.`,
          imagemUrl: telaInstagramFace21,
        },
        {
          titulo: "Ir para configurações do app",
          descricao:
            `Em seguida, acesse a barra lateral em "Configurações do app" e "Básico".`,
          imagemUrl: telaInstagramFace22,
        },
        {
          titulo: "Copiar campos",
          descricao:
            `Você será redirecionado para a página com os campos "ID de Aplicativo" e "Chave Secreta do Aplicativo”. Copie estes dois campos.`,
          imagemUrl: telaInstagramFace23,
        },
        {
          titulo: "Ajustar url e copiar seu retorno gerado",
          descricao:
            `Ao copiar os campos, cole-os nas partes entre chaves da url destacada abaixo, juntamente com o token de acesso. Após a url ajustada, cole-a na barra de pesquisa e copie o token que será gerado na tela (necessário remover as chaves "{ }" antes do envio, e verificar se não há nenhum espaço em branco).`,
          imagemUrl: telaInstagramFace24Grifada,
          fieldHighlight: `https://graph.facebook.com/v19.0/oauth/access_token?grant_type=fb_exchange_token&client_id={ID de aplicativo}&client_secret={Chave Secreta do Aplicativo}&fb_exchange_token={Token de acesso}`
        },
        {
          titulo: "Colar token de acesso no CMS",
          descricao:
            `Após a cópia do token, acesse a plataforma CMS e cole-o no campo "Token de acesso".`,
          imagemUrl: telaInstagramFace28,
        },
        {
          titulo: "Colar retorno de token e copiar campos",
          descricao:
            `Com o mesmo token copiado, coloque-o no campo "Token de acesso" da url destacada abaixo e cole essa url na barra de pesquisa do navegador (necessário remover as chaves "{ }" antes do envio, e verificar se não há nenhum espaço em branco). Em seguida, aparecerá os campos descritos na imagem, então, copie os campos "id" e "name".`,
          imagemUrl: telaInstagramFace25,
          fieldHighlight: "https://graph.facebook.com/v19.0/me/accounts?access_token={Token de acesso}"
        },
        {
          titulo: "Colar campos",
          descricao:
            `Ao copiar o id e name, volte para a plataforma CMS, e coloque o id copiado no campo "Page ID", e o name copiado no campo "Nome do usuário", como demonstrado na imagem.`,
          imagemUrl: telaInstagramFace30,
        },
        {
          titulo: "Configuração concluída",
          descricao:
            `Parabéns! A configuração foi concluída com sucesso e você já pode publicar no Facebook.`,
          imagemUrl: facebookBanner,
        },
      ]
    }
    
    return passosComuns;
  };    

  const passos = getPassosDaGuia();

  const handleAvancar = () => {
    if (passoAtual < passos.length - 1) {
      setPassoAtual(passoAtual + 1);
    }
  };

  const handleVoltar = () => {
    if (passoAtual > 0) {
      setPassoAtual(passoAtual - 1);
    }
  };

  return (
    <Fade in={isOpen}>
    <div className="guia-ajuda-modal">
      <div className="guia-ajuda-modal__sobreposicao"></div>

      <div className="guia-ajuda-modal__container-conteudo">
        <div className="guia-ajuda-modal__container">
          <div className="guia-ajuda-modal__cabecalho">
            <div className="guia-ajuda-modal__info-cabecalho">
              <h2 className="guia-ajuda-modal__titulo">Guia de Configuração</h2>
              <p className="guia-ajuda-modal__subtitulo">{socialMedia}</p>
            </div>
            <div className="guia-ajuda-modal__acoes-cabecalho">
              <span className="guia-ajuda-modal__contador-passo">
                {passoAtual + 1}/{passos.length}
              </span>
              <button onClick={handleClose} className="guia-ajuda-modal__botao-fechar">
                <X size={20} />
              </button>
            </div>
          </div>

          <div className="guia-ajuda-modal__secao-imagem">
            {(() => {
              const url = passos[passoAtual].imagemUrl;
              const ext = url.split('?')[0].split('.').pop()?.toLowerCase();
              if (ext === 'mp4' || ext === 'webm') {
                return (
                  <video className="guia-ajuda-modal__imagem" controls>
                    <source src={url} type={`video/${ext}`} />
                    Seu navegador não suporta a tag de vídeo.
                  </video>
                );
              } else {
                return (
                  <img
                    src={url}
                    alt={passos[passoAtual].titulo}
                    className="guia-ajuda-modal__imagem"
                  />
                );
              }
            })()}
          </div>

          <div className="guia-ajuda-modal__conteudo">
            <h3 className="guia-ajuda-modal__titulo-imagem">{passos[passoAtual].titulo}</h3>
            <p
              className="guia-ajuda-modal__descricao"
              dangerouslySetInnerHTML={{ __html: passos[passoAtual].descricao }}
            />
            {passos[passoAtual].fieldHighlight && (
              <div className="guia-ajuda-modal__destaque">
                <p className="guia-ajuda-modal__texto-destaque">
                  Campo destacado:{" "}
                  <span className="guia-ajuda-modal__span-destaque">
                    {passos[passoAtual].fieldHighlight}
                  </span>
                </p>
              </div>
            )}
          </div>

          <div className="guia-ajuda-modal__rodape">
            <button
              onClick={handleVoltar}
              disabled={passoAtual === 0}
              className="guia-ajuda-modal__botao guia-ajuda-modal__botao--anterior"
            >
              <ChevronLeft size={18} className="guia-ajuda-modal__icone-botao" />
              Anterior
            </button>

            {passoAtual === passos.length - 1 ? (
              <button
                onClick={handleClose}
                className="guia-ajuda-modal__botao guia-ajuda-modal__botao--concluir"
              >
                Concluir
              </button>
            ) : (
              <button
                onClick={handleAvancar}
                className="guia-ajuda-modal__botao guia-ajuda-modal__botao--proximo"
              >
                Próximo
                <ChevronRight size={18} className="guia-ajuda-modal__icone-botao" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
    </Fade>
  );
};

export default HelpGuideModal;
